import BaseService from "../../base/base_service";
import IExternalLinksProxyService from "./external_links_proxy_service_interface";
import {
    IOpenRegistrationOptions
} from "../../../../app-react/services/external-links/handlers/registration/registration.external-link-handler.interface";
import {IExternalLinksProxy} from "../../../../common/interfaces/external-links-proxy.interface";
import {
    IOpenGameLimitsOptions,
    IOpenPendingLoginOptions
} from "../../../../app-react/services/external-links/external-links.service.interface";
import {OpenCashierOptions} from "../../../../common/interfaces/cashier.service.interface";

interface ExternalLinksProxyServiceParams {
    externalLinksService: () => IExternalLinksProxy;
}

export default class ExternalLinksProxyService extends BaseService implements IExternalLinksProxyService {

    static CLASS = 'ExternalLinksProxyService';

    private _params: ExternalLinksProxyServiceParams;

    init(params: ExternalLinksProxyServiceParams) {
        this._params = params;
    }

    openCashier(options?: OpenCashierOptions): Promise<void> {
        return this._params.externalLinksService().openCashier(options);
    }

    openMembership(options?: IOpenRegistrationOptions): Promise<void> {
        return this._params.externalLinksService().openMembership(options);
    }

    openForgotPassword(): Promise<void> {
        return this._params.externalLinksService().openForgotPassword();
    }
    openForgotUserName(): Promise<void> {
        return this._params.externalLinksService().openForgotUserName();
    }

    openPendingLogin(options: IOpenPendingLoginOptions): Promise<void> {
        return this._params.externalLinksService().openPendingLogin(options);
    }

    openUploadDocument(): Promise<void> {
        return this._params.externalLinksService().openUploadDocument();
    }
    openGameLimits(options:IOpenGameLimitsOptions){
        return this._params.externalLinksService().openGameLimits(options);
    }
}